import { render, staticRenderFns } from "./zDialogoSimNao.vue?vue&type=template&id=38d37f5c&scoped=true"
import script from "./zDialogoSimNao.vue?vue&type=script&lang=js"
export * from "./zDialogoSimNao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d37f5c",
  null
  
)

export default component.exports